export default "__VITE_ASSET__CkDYyYd7__"